<script lang="ts" generics="TValues">
    import type { Field, Form } from '@jmvdevelop/svelte-form';
    import { getContainer } from '$components/Context/ContainerContext.js';
    import AsyncSelect from '$components/Form/AsyncSelect.svelte';

    import { loadOptions, optionToValue, valueToId, valueToOption } from './utils.js';

    export let form: Form<TValues, string>;
    export let field: Field<TValues, number | null>;
    export let placeholder: string = "Secteur d'activité";
    export let leaf: boolean | null = null;
    export let parentId: number | null = null;
    export let defaultClass: string | undefined = undefined;
    export let id: string | null = null;

    let className: string = '';
    export { className as class };

    export let showChevron = false;

    const { apollo } = getContainer();
</script>

{#key `${leaf}-${parentId}`}
    <AsyncSelect
        {defaultClass}
        class={className}
        {form}
        {field}
        {placeholder}
        loadOptions={(q) => loadOptions(apollo, q, leaf, parentId)}
        {optionToValue}
        valueToOption={(v) => valueToOption(apollo, v)}
        {valueToId}
        {showChevron}
        optionId="id"
        label="name"
        {id}
    >
        <div slot="option" let:option class="p-[10px]">
            <span>{option.name}</span>
            {#if option.parent != null}
                <div class="text-sm text-gray-600 [.item.active_&]:text-white">
                    {option.parent.name}
                </div>
            {/if}
        </div>
    </AsyncSelect>
{/key}
